import { AuthGuard } from './../shared/guard/auth.guard';
import { Injectable } from '@angular/core';
import {
  AngularFireDatabase,
  AngularFireList,
  AngularFireObject,
} from '@angular/fire/database';
import * as firebase from 'firebase';
import { Business } from '../models/business';
import { ActivatedRoute, Router } from '@angular/router';
import {
  AngularFirestore,
  AngularFirestoreCollection,
} from '@angular/fire/firestore';
import { data } from 'jquery';
import { AuthService } from '../shared/service/auth.service';

@Injectable({
  providedIn: 'root',
})
export class FireAssessmentService {
  assessmentsRef: AngularFireList<any>; // Reference to Assessment data list, its an Observable
  assessmentRef: AngularFireObject<any>; // Reference to assessment object
  public database = firebase.database();
  public UserAssessmentInput;
  public ref;
  public actRoute: ActivatedRoute;
  public router: Router;
  public auth: AuthGuard;
  public dbStore = firebase.firestore();
  private dbPath = 'users';
  private assessmentsTable = 'assessment-inputs';

  sustainibleAssessmentRef: AngularFirestoreCollection<Business> = null;

  constructor(
    private db: AngularFireDatabase,
    private guard: AuthGuard,
    private authService: AuthService,
    private dbstore: AngularFirestore
  ) {
    this.sustainibleAssessmentRef = dbstore.collection(this.assessmentsTable);
  }

  // Firestore Assessment Create the Assessment in FireStore
  createSustainibleeAssessment(sustainible: Business): void {
    this.sustainibleAssessmentRef.add({ ...sustainible });
  }

  updateSustainibleeAssessment(id: string, value: any): Promise<void> {
    return this.sustainibleAssessmentRef.doc(id).update(value);
  }

  deleteSustainibleeAssessment(id: string): Promise<void> {
    return this.sustainibleAssessmentRef.doc(id).delete();
  }

  readSustainibleeAssessmentList(): AngularFirestoreCollection<Business> {
    return this.sustainibleAssessmentRef;
  }

  readSustainibleAssessment(id: string) {
    return this.sustainibleAssessmentRef.doc(id);
  }

  deleteAllSustainibleeAssessment() {
    this.sustainibleAssessmentRef.get().subscribe(
      (querySnapshot) => {
        querySnapshot.forEach((doc) => {
          doc.ref.delete();
        });
      },
      (error) => {
        console.log('Error deleting all documents: ', error);
      }
    );
  }

  /**
   * Create assessment in firestore
   * @param business - data about business assessment
   * @returns
   */

  async createAssessment(business: Business): Promise<string> {
    const adminCodePayload: any = (
      await this.dbStore
        .collection(this.dbPath)
        .doc(this.authService.userData?.uid || this.guard.uid)
        .get()
    )?.data()?.adminCode;
    const data = {
      userID: this.authService.userData?.uid || this.guard.uid,
      adminCode: !adminCodePayload?.disabled ? adminCodePayload: null,
      ...business,
    };

    const res = await this.sustainibleAssessmentRef.add(data);

    return res.id;
  }

  public adminCode2: any;
  assessmentInput: any;

  globalAdminCode(uid: string) {
    this.dbStore
      .collection(this.dbPath)
      .doc(uid)
      .get()
      .then((snapshot) => {
        this.assessmentInput = snapshot.data();
        this.adminCode2 = this.assessmentInput.adminCode;
      });
  }


  ReadAssessment(id: string) {
    this.assessmentRef = this.db.object(`users/${this.guard.uid}/` + id);
    return this.assessmentRef;
  }

  readAssessmentsList() {
    this.globalAdminCode(this.authService.userData?.uid || this.guard.uid);

    const list = this.dbstore.collection<any>(this.assessmentsTable, (ref) =>
      ref.where('userID', '==', this.guard.uid)
    );
    return list;
  }

  UpdateAssessments(business: Business) {
    this.assessmentRef.update({
      busiName: business.busiName,
      busiRegType: business.busiRegType,
      busiFirstName: business.busiFirstName,
      busiLastName: business.busiLastName,
      busiTelephone: business.busiTelephone,
      busiEmail: business.busiEmail,
      busiWebsite: business.busiWebsite,
      busiStreet: business.busiStreet,
      busiaddress2: business.busiaddress2,
      busiCity: business.busiCity,
      busiState: business.busiCity,
      busiZipcode: business.busiZipcode,
      // busiDemographics: business.busiDemographics,
      offerType: business.offerType,
      offerIndustry: business.offerIndustry,
      offerFrequency: business.offerFrequency,
      offerInnovation: business.offerInnovation,
      offerDifferentiation: business.offerDifferentiation,
      offerImproveLife: business.offerImproveLife,
      offerMarkEntry: business.offerMarkEntry,
      offerSupplierPower: business.offerSupplierPower,
      offerSupplierType: business.offerSupplierType,
      offerBuyerPower: business.offerBuyerPower,
      offerUrgency: business.offerUrgency,
      industryNEServing: business.industryNEServing,
      //  marketTargetIndustry: business.marketTargetIndustry,
      mTargetB2BC: business.mTargetB2BC,
      marketTargetLocation: business.marketTargetLocation,
      marketTargetAge: business.marketTargetAge,
      marketTargetEthnicity: business.marketTargetEthnicity,
      marketTargetGender: business.marketTargetGender,
      // marketTargetHousehold: business.marketTargetHousehold,
      marketTargetOccupation: business.marketTargetOccupation,
      //marketTargetIncome: business.marketTargetIncome,
      marketTargetB2BIndustry: business.marketTargetB2BIndustry,
      // marketTargetB2BSize: business.marketTargetB2BSize,
      marketTargetB2BOccupation: business.marketTargetB2BOccupation,
      marketTargetB2BDecisionMaker: business.marketTargetB2BDecisionMaker,
      capitalSeeking: business.capitalSeeking,
      pmfOverproduction: business.pmfOverproduction,
      pmfCompetitorDissatisfaction: business.pmfCompetitorDissatisfaction,
      teamLeaderSerialEntrp: business.teamLeaderSerialEntrp,
      teamRole: business.teamRole,
      teamIndustryKnowledge: business.teamIndustryKnowledge,
      teamTime: business.teamTime,
      teamNetwork: business.teamNetwork,
      teamUnadv: business.teamUnadv,
      teamTimeManage: business.teamTimeManage,
      teamAccountability: business.teamAccountability,
      teamUnproductivity: business.teamUnproductivity,
      teamPassion: business.teamPassion,
      teamRisk: business.teamRisk,
      teamOpenness: business.teamOpenness,
      teamTrust: business.teamTrust,
      teamRecognition: business.teamRecognition,
      acceptTerms: business.acceptTerms,
      // chartData
    });
  }
  DeleteAssessment() {
    this.assessmentRef = this.db.object('users/');
    this.assessmentRef.remove();
  }
}
